import instance from "./index";

export const viewProjectWorkRoomImage = async (
  projectId,
  fileName,
  resourceName = "images",
) => {
  if (!projectId || !fileName || !resourceName) return null;

  try {
    const response = await instance.get(
      `/projectWorkRoom/view/byProjectId/${projectId}/${encodeURIComponent(fileName)}/${encodeURIComponent(resourceName)}`,
      { responseType: "blob" },
    );
    const blob = response?.data;
    if (!(blob instanceof Blob) || blob.size === 0) return null;
    return URL.createObjectURL(blob);
  } catch {
    return null;
  }
};

export const getProjectWorkRoomByProjectId = async (projectId) => {
  try {
    const response = await instance.get(
      `/projectWorkRoom/getByProjectId/${projectId}`,
    );
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to load workroom";
    throw new Error(message);
  }
};

export const createProjectWorkRoom = async (formData) => {
  try {
    const response = await instance.post("/projectWorkRoom", formData);
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to create workroom";
    throw new Error(message);
  }
};

export const updateProjectWorkRoomByProjectId = async (projectId, formData) => {
  try {
    const response = await instance.put(
      `/projectWorkRoom/updateProjectWorkRoomByProjectId/${projectId}`,
      formData,
    );
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to update workroom";
    throw new Error(message);
  }
};

export const deleteProjectWorkRoomResource = async (projectId, fileNames) => {
  const list = (Array.isArray(fileNames) ? fileNames : [fileNames])
    .map(String)
    .map((name) => name.trim())
    .filter(Boolean);

  if (!projectId || !list.length) {
    throw new Error("projectId and at least one file name are required");
  }

  try {
    const response = await instance.delete("/projectWorkRoom/deleteResource", {
      data: {
        projectId,
        fileNames: list,
      },
    });
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to delete workroom resource";
    throw new Error(message);
  }
};

export const createActivation = async (formData) => {
  try {
    const response = await instance.post("/activations", formData);
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to create activation";
    throw new Error(message);
  }
};

export const getActivationAssets = async (activationId, fileName) => {
  try {
    const response = await instance.get(`activations/view/byActivationId/${activationId}/${fileName}`,  { responseType: "blob" });
    return response;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to get activation assets";
    throw new Error(message);
  }
};


export const updateActivation = async (formData, activationId) => {
  try {
    const response = await instance.put(`activations/update/${activationId}`, formData);
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to create workroom";
    throw new Error(message);
  }
};

export const getActivations = async () => {
  try {
    const response = await instance.get("/activations");
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to create workroom";
    throw new Error(message);
  }
};

export const deleteVariantById = async (variantId) => {
  try {
    const response = await instance.delete(`/variants/deleteVariant/${variantId}`);
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to create workroom";
    throw new Error(message);
  }
};

export const getActivationsByProjectId = async (projectId) => {
  try {
    const response = await instance.get(`/activations/${projectId}`);
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to create workroom";
    throw new Error(message);
  }
};


